<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            消费流水统计
        </div>


        <div style="padding: 20px;">
          <div v-if="showModal" class="mask">
            <div class="lodingsIcon">
              <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
            </div>
          </div>

            <div>
                <el-row>
                    <div style="float:right">
                        <span class="demonstration">所属区域：</span>
                        <elSelectTree :options='zoneValue' accordion :props="zoneProps" v-on:getZoneValue="getZoneValue" style="width:250px;margin-right:20px"></elSelectTree>
                        <span class="demonstration">起止时间：</span>
                        <el-date-picker
                            ref="picker"
                            v-model="datetimerangeValue"
                            type="daterange"
                            :clearable='false'
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width:250px;margin-right:20px">
                        </el-date-picker>
                      <el-button type="success" icon="el-icon-download" style="margin-right:10px" @click="download">导出</el-button>
                        <el-button type="primary" icon="el-icon-search" @click="searchGetList()">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>
            <!-- <div>
                <el-row>
                    <el-col :span="12">
                        <ve-histogram :data="chartData" :settings="chartSettings"></ve-histogram>
                    </el-col>
                    <el-col :span="12">
                        <ve-histogram :data="chartData" :settings="chartSettings"></ve-histogram>
                    </el-col>
                </el-row>
            </div> -->
            <div>
                <template>

                    <el-table
                        :data="tableData"
                        :height="th"
                        border
                        v-loading="loading"
                        style="width: 100%;">

                        <el-table-column prop="zoneName" label="所属区域" width="320"></el-table-column>
                        <el-table-column prop="businessName" label="商家名称"></el-table-column>
                        <el-table-column prop="name" label="姓名" width="120"></el-table-column>
                        <el-table-column prop="phone" label="联系电话" width="120"></el-table-column>
                        <el-table-column prop="idCard" label="身份号" width="200"></el-table-column>
                        <el-table-column prop="payMoney" label="消费金额" width="105"></el-table-column>
                        <el-table-column prop="currentBalance" label="余额" width="80"></el-table-column>
                        <el-table-column
                                prop="isSchedule"
                                :formatter="isSchedules"
                                label="预订单">
                        </el-table-column>
                        <el-table-column
                                prop="orderType"
                                :formatter="statusTitle"
                                label="订单类型" width="150">
                        </el-table-column>
                        <el-table-column prop="createTime" :formatter="timefilter" width="200" label="创建时间"></el-table-column>
                    </el-table>
                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                    

                </template>
            </div>

        </div>

        <!-- <Add ref="myAdd" v-show="showModalAdd" v-bind:areaValue="areaValue" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit"  v-bind:areaValue="areaValue"  v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit> -->

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import elSelectTree from "../../../components/ElSelectTree"
    // import Edit from "./Edit";
    // import Add from "./Add";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
             this.chartSettings = {
                axisSite: { right: ['下单率'] },
                yAxisType: ['KMB', 'percent'],
                yAxisName: ['数值', '比率'],
                showLine: ['下单用户']
            }
            return{
              showModal:false,
                loading:false,
                showModalAdd:false,
                showModalEdit:false,
                tableData:null,
                zoneValue:[],
                zoneCode:'',
                datetimerangeValue:'',
                areaValue:[],
                idNumber:'',
                phone:'',
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                name:'',
                zoneProps:{
                    emitPath:false,
                    value: 'zoneCode',
                    // 显示的文字字段名
                    label: 'name',
                    // 子层级字段名
                    children: 'listZoneDTO'
                },
                chartData: {
                columns: ['日期', '访问用户', '下单用户', '下单率'],
                rows: [
                    { '日期': '1/1', '访问用户': 1393, '下单用户': 1093, '下单率': 0.32 },
                    { '日期': '1/2', '访问用户': 3530, '下单用户': 3230, '下单率': 0.26 },
                    { '日期': '1/3', '访问用户': 2923, '下单用户': 2623, '下单率': 0.76 },
                    { '日期': '1/4', '访问用户': 1723, '下单用户': 1423, '下单率': 0.49 },
                    { '日期': '1/5', '访问用户': 3792, '下单用户': 3492, '下单率': 0.323 },
                    { '日期': '1/6', '访问用户': 4593, '下单用户': 4293, '下单率': 0.78 }
                ]
                }
            }
        },
        // components:{
        //     Add,Edit
        // },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },
        components:{
            elSelectTree
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            init(){
                const end = new Date();
                const start=new Date(end - 1000 * 60 * 60 * 24 * 30);
                this.datetimerangeValue=[start, end];
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Zone/ListForStaff",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        var data=JSON.stringify(response.data.data);
                        data=JSON.parse(data.replace(/"listZoneDTO":\[\],/g,''))
                        this.zoneValue = data;
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                })
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Area/ListAll",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            var data=JSON.stringify(response.data.data);
                            data=JSON.parse(data.replace(/"listAreaDTO":\[\],/g,''))
                            this.areaValue = data
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
          download(){
            this.$confirm('是否导出当前列表?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.showModal=true
              var that=this

              this.$axios.get(this.$shopUrl+'ExportOldest/GetBusinessWater',{
                responseType: 'blob',
                params:{
                  timeStr: timeStr,
                  sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                  staffCode: getStaffCode(),
                  startTime:timefilters(this.datetimerangeValue[0]),
                  endTime:timefilters(this.datetimerangeValue[1]),

                }
              }).then(
                  (response) => {
                    if(response.data.type=='application/json'){
                      this.$message({type: 'info', message: '暂无数据'});
                      that.showModal=false;
                    }else{
                      let fileName = '商家消费流水统计.xlsx';
                      that.file(response,fileName);
                      that.showModal=false;
                    }

                  }
              )
              this.dialogFormVisible=false
            }).catch(e=>e)
          },
          file(response,fileName){
            let blob = new Blob([response.data]);
            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob,fileName);
            } else {
              let elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob)
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href);
              document.body.removeChild(elink);
            }
          },
            getZoneValue(val){
                this.zoneCode=val
            },
            timefilter(row, column, cellValue){
                return timefilters(cellValue)
            },
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            searchGetList(){
                this.getList();
            },
            getList(isSearch){
                if(isSearch)this.currentPage=1
              this.loading=true;
                var zoneCode='00000000-0000-0000-0000-000000000000'
                if(this.zoneCode){
                    zoneCode=this.zoneCode
                }
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"OrderBusiness/PageForBusinessWater",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        startTime:timefilters(this.datetimerangeValue[0]),
                        endTime:timefilters(this.datetimerangeValue[1]),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                        zoneCode:zoneCode,
                    }
                }).then( (response)=> {
                  this.loading=false;
                    console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            applyTypeTitle(row){
                if(row.applyType == 0){
                    return "80-99周岁";
                }
                if(row.applyType == 1){
                    return "100周岁及以上";
                }
            },
            genderTitle(row, column, cellValue){
                if(cellValue == 0){
                    return "女";
                }
                if(cellValue == 1){
                    return "男";
                }
            },
             statusTitle(row, column, cellValue){
                 return this.allStatus(cellValue,["",'普通商品订单','社会化服务订单','政府购买服务订单']);
            },
            isSchedules(row, column, cellValue){
                 return this.allStatus(cellValue,['否','是']);
            },
            allStatus(row,status){
                for(var i in status){
                    if(i==row){
                        return status[i]
                    }
                }
                return "其它";
            }


        }
    }
</script>

<style lang="scss" scoped>
.mask {
  background-color: rgb(0, 0, 0);
  opacity: 0.3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 199
}

.mask .lodingsIcon {
  /* margin-top: 47vh; */
  margin: 47vh auto;
  height: 6vh;
  width: 300px;
  font-size: 18px;
  color: white;
}

.lodingsIcon i {
  z-index: 200;
  font-size: 25px;
  margin-right: 10px;
}
</style>
